import isNumericDataType from 'scoreboard/components/is-numeric-data-type'

const CATEGORY = 'category'
const RANGE = 'range'
const VALUE = 'value'

/**
 * Returns whether the breakdown is on a dataset field category/range or value
 *
 * @param {Object} field - the dataset field for the breakdown
 * @param {BreakdownBy} breakdownBy
 *
 * @returns {CATEGORY|RANGE|VALUE}
 */
function breakdownByFieldType ({ field, breakdownBy }) {
	if (breakdownBy == 'every-range' || breakdownBy == 'specific-ranges') {
		return isNumericDataType(field.dataType) ? RANGE : CATEGORY
	} else if (breakdownBy == 'every-value' || breakdownBy == 'specific-values') {
		return VALUE
	} else {
		throw new Error('unsupported breakdownBy: ' + breakdownBy)
	}
}

export default breakdownByFieldType
export { CATEGORY, RANGE, VALUE }

breakdownByFieldType.__filename__ = 'charts/edit/sort/breakdown-by-field-type.js'
